<script lang="ts">
  import { onMount } from "svelte";
	import BlueButton from "../BlueButton.svelte";
	import { ApiService } from "../../services/api.service";

	import Checkbox from "../../atoms/forms/Checkbox.svelte";
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import SectionBoard from "../../molecules/SectionBoard.svelte";

	export let klass = ""

	let id = 0
	let email = ''
	let tel = ''
	let loading = false

	const handleEmail = (event) => {
  	email = event.detail.value
	}

	const handleTel = (event) => {
  	tel = event.detail.value
	}

	const save = async () => {
		const client = ApiService.createClient()
		loading = true
		const { data } = await client.post('/contact', {
			email,
			tel
		})
		console.log(data)
		loading = false
	}

	onMount(async () => {
		const client = ApiService.createClient()
		const { data } = await client.get('/contact')
		console.log(data)
		if (!data.contact) {
			return
		}
		email = data.contact.email
		tel = data.contact.tel
	})
</script>

<SectionBoard klass={klass}>
	<h2 class="font-semibold">
		連絡先設定
	</h2>

	<div class="mt-6">
		<FormWithLabel label="メールアドレス" placeholder="info@example.com" input={handleEmail} value={email} />
	</div>

	<div class="mt-6">
		<FormWithLabel label="電話番号" placeholder="0120-1234-5678" input={handleTel} value={tel} />
	</div>

	<BlueButton click={save} rounded klass="mt-4">
		更新する
	</BlueButton>
</SectionBoard>